import * as React from 'react';
import { ProtectedPageWrapper } from '../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { LearningModuleContent } from '../../_components/learning/LearningModuleContent';

export function LearningModulePage (): JSX.Element
{
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewCustomFormAnswerList']} selectedMenuItemKey={'learning'}>
            <LearningModuleContent />
        </ProtectedPageWrapper>
    );
}